var DialogView = require('dialogview');


var NickservView = DialogView.extend({
    el: '#nickservContainer',
    initialize: function (options) {
        this.setErrorMessage = $('p#nickservPasswordSetError');
        this.cidInputs = this.$('input[name=cid]');
        this.nsPass = $('input#nsPass');
        this.netName = $('#nickservNetname');
        this.host = $('#nickservHost');
        this.nick = $('#nickservNick');
        
        this.afterHide = _.bind(function () {
            this.model = null;
            this.hideErrors();
            this.nsPass.val('');
            this.cidInputs.val('');
            this.netName.empty();
            this.host.empty();
            this.nick.empty();
            this.nsPass.prop('disabled', true);
        }, this);
        DialogView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'submit form#nickservHelpForm': 'submitHelp',
        'submit form#nickservPasswordSetForm': 'submitSet'
    }),
    submitHelp: function (e) {
        e.preventDefault();
        this.model.nickservRegisterHelp(_.bind(function (response) {
            this.hide();
            if (!response.success) {
                this.model.trigger('postError', response);
            }
        }, this));
    },
    submitSet: function (e) {
        e.preventDefault();
        this.model.setNickservPassword(this.nsPass.val(), _.bind(function (response) {
            if (response.success) {
                this.hide();
            } else {
                var message;
                switch (response.message) {
                case 'connection_unavailable':
                    message = 'This connection is temporarily unavailable. Try again later.';
                    break;
                case 'server_error':
                    message = 'There was a problem joining this network';
                    break;
                default:
                    message = 'Error setting NickServ password: ' + response.message;
                    break;
                }
                this.showSetError(message);
            }
        }, this));
    },
    showSetError: function (message) {
        this.setErrorMessage.text(message).fadeIn('fast');
    },
    hideErrors: function () {
        this.setErrorMessage.hide();
    },
    show: function (connection) {
        this.model = connection;
        this.netName.text(this.model.getName());
        this.host.text(this.model.getHost());
        this.nick.text(this.model.get('nick'));
        this.nsPass.val(this.model.get('nickserv_pass'));
        this.nsPass.prop('disabled', false);
        this.cidInputs.val(this.model.getCid());
        DialogView.prototype.show.call(this);
    }
});


module.exports = NickservView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/nickservview.js
// module id = Hg18
// module chunks = 1